module.exports = __webpack_public_path__ + "img/spiruline.41b7421a.jpg";